<div class="header-container">
  <p>Please take 2 minutes to fill <a href="" (click)="navigate($event)" >this user survey</a> and help us improve ClearML<p>
  <i class="close fas fa-times pointer" (click)="dismiss.emit(true)"></i>
</div>
